import React, { useRef, useState } from "react";
import StepsDisplay from "../StepsDisplay";
import arrow_white from "../../assets/arrow_white.svg";
import treatment_icon from "../../assets/treatment_icon.svg";
import calendericon from "../../assets/calendericon.svg";
import clock_black from "../../assets/clock_black.svg";
import tick from "../../assets/tick.svg";
import untick from "../../assets/untick.svg";
import { formatDateDutch } from "../../utils/formatDateDutch";
import { toast } from "alert";
import { useDispatch } from "react-redux";
import { updateAppointment, addAppointment } from "../../redux/actions/appointments";
// import { clearOrder } from "../../redux/slices/orders";
// import { sendEmail } from "../../redux/actions/emailSend";
import SmallLoader from "../SmallLoader";
import SignatureCanvas from "react-signature-canvas";
import { storage } from "../../firebase";
import { ref, uploadString, getDownloadURL } from "firebase/storage";
import { handlePayment } from "../../redux/actions/handlePayment";

const StepThree = ({
  progressWidth,
  step,
  inputHandle,
  setInputHandle,
  date
  // resetStep,
  // initialState,
}) => {
  const sigCanvasRef = useRef();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [signatureError, setSignatureError] = useState(false);
  const [questionsError, setQuestionsError] = useState(false);
  const [showNewSignature, setShowNewSignature] = useState(false);
  const coverage = [
    { id: 1, text: "Ben je zwanger?" },
    // { id: 2, text: "Ben je 18 jaar en ouder?" },
    { id: 3, text: "Maak je gebruik van fillers?" },
    { id: 4, text: "Maak je gebruik van botox injecties?" },
    { id: 5, text: "Rook je?" },
    { id: 6, text: "Doe je aan intensieve sport?" },
    { id: 7, text: "Heb je recent chirurgie onderstaan in je gezicht?" },
    { id: 8, text: "Heb je wel eens last van een koortslip?" },
    { id: 9, text: "Gebruik je bloedverdunners?" },
    { id: 10, text: "Ben je ergens allergisch voor?" },
    { id: 11, text: "Gebruik je overige medicatie op dit moment?" },
    { id: 12, text: "Gevoelig tegen producten die alcohol bevatten?" }
  ];
  const startTime = inputHandle.appointmentTime.split("-")[0].trim();
  inputHandle.coverageResponses = inputHandle.coverageResponses || {};
  const appointmentId = localStorage.getItem("appointmentId");

  const existingAppointmentData = localStorage.getItem("appointmentData");
  const hasExistingSignature = existingAppointmentData
    ? JSON.parse(existingAppointmentData)?.signatureURL
    : null;

  const handleCoverageChange = (id, value) => {
    setInputHandle((prev) => ({
      ...prev,
      coverageResponses: {
        ...prev.coverageResponses,
        [id]: value
      }
    }));
  };

  const clearStoredSignature = () => {
    const appointmentData = localStorage.getItem("appointmentData");
    if (appointmentData) {
      const parsedData = JSON.parse(appointmentData);
      delete parsedData.signatureURL;
      localStorage.setItem("appointmentData", JSON.stringify(parsedData));
    }
    setShowNewSignature(true);
  };

  const submit = async (e) => {
    setSignatureError(false);
    setQuestionsError(false);
    setLoading(true);

    try {
      const allQuestionsAnswered = coverage.every((item) =>
        inputHandle.coverageResponses?.hasOwnProperty(item.id)
      );

      if (!allQuestionsAnswered) {
        setQuestionsError(true);
        setLoading(false);
        return;
      }

      let signatureURL = "";

      if (hasExistingSignature && !showNewSignature) {
        signatureURL = hasExistingSignature;
      } else {
        if (!sigCanvasRef.current || sigCanvasRef.current.isEmpty()) {
          setSignatureError(true);
          setLoading(false);
          return;
        }

        const signatureDataUrl = sigCanvasRef.current
          ? sigCanvasRef.current.getCanvas().toDataURL("image/png")
          : null;

        if (signatureDataUrl) {
          const signatureRef = ref(
            storage,
            `signatures/${inputHandle.invoiceNumber}.png`
          );

          await uploadString(signatureRef, signatureDataUrl, "data_url");
          signatureURL = await getDownloadURL(signatureRef);
        }
      }

      const appointmentData = {
        ...inputHandle,
        signatureURL,
        timeslot:
          formatDateDutch(date).split(",")[0] +
          "-" +
          inputHandle.appointmentTime,
        appointmentDate:
          formatDateDutch(date).split(",")[1] +
          " " +
          new Date(date).getFullYear()
      };

      if (!appointmentId || appointmentId === "undefined" || appointmentId === "null") {
        toast.error("Afspraakgegevens ontbreken. Ga terug naar stap 1 en probeer opnieuw.");
        return;
      }

      const updateResult = await dispatch(
        updateAppointment({ id: appointmentId, updatedData: appointmentData })
      );

      if (updateResult.error) {
        const errorPayload = updateResult.payload || "";

        if (errorPayload.includes("not-found")) {
          localStorage.removeItem("appointmentId");
          localStorage.removeItem("appointmentInvoiceNumber");

          const freshResult = await dispatch(addAppointment({ ...appointmentData, paymentStatus: "pending" }));
          const freshId = freshResult?.payload?.appointmentId;

          if (freshId) {
            localStorage.setItem("appointmentId", freshId);
            localStorage.setItem("appointmentInvoiceNumber", appointmentData.invoiceNumber);
          } else {
            toast.error("Kon afspraak niet aanmaken. Controleer uw verbinding en probeer opnieuw.");
            return;
          }
        } else {
          toast.error("Kon afspraak niet opslaan. Probeer opnieuw.");
          return;
        }
      }

      localStorage.setItem("appointmentData", JSON.stringify(appointmentData));

      await handlePayment(inputHandle);
    } catch (err) {
      toast.error("Er is iets misgegaan bij het verzenden.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="right">
      <div className="calender_container bevestiging_container">
        <h3 className="georgia-font fw-bold">Toestemmingsverklaring</h3>
        <div className="info-mobile">
          <p>
            Dit is de laatste stap vóór je afspraak. Beantwoord alle vragen en
            onderteken het formulier. Na afronding ontvang je direct een
            bevestiging per mail.
          </p>
        </div>
        <div className="coverage_container">
          <ul className="list-unstyled d-flex flex-column gap-3">
            {coverage.map((item) => {
              const coverageResponses = inputHandle.coverageResponses || {};
              const isYes = coverageResponses[item.id] === true;
              const isNo = coverageResponses[item.id] === false;

              return (
                <li
                  className="d-flex justify-content-between align-items-center gap-3"
                  key={item.id}
                >
                  <div>{item.text}</div>
                  <div className="d-flex gap-3">
                    <div
                      className="d-flex gap-1 cursor-pointer"
                      onClick={() => handleCoverageChange(item.id, true)}
                    >
                      ja{" "}
                      {isYes ? (
                        <img src={tick} alt="" />
                      ) : (
                        <img src={untick} alt="" />
                      )}
                    </div>
                    <div
                      className="d-flex gap-1 cursor-pointer"
                      onClick={() => handleCoverageChange(item.id, false)}
                    >
                      Nee{" "}
                      {isNo ? (
                        <img src={tick} alt="" />
                      ) : (
                        <img src={untick} alt="" />
                      )}
                    </div>
                  </div>
                </li>
              );
            })}
            {questionsError && (
              <li className="question_error">Alle velden zijn verplicht.</li>
            )}
          </ul>
        </div>
      </div>
      <div className="timetable bevestiging_container_2 d-flex flex-column justify-content-between h-100">
        <div className="top_header">
          <h5 className="fw-600 mb-3 reservering_number">
            Reservering Nr: <span>{inputHandle.invoiceNumber}</span>
          </h5>
          {/* <StepsDisplay progressWidth={progressWidth} step={step} /> */}
        </div>
        <div className="bevestiging-content">
          <div className="info-desktop">
            <p className="body_text">
              Dit is de laatste stap vóór je afspraak. Beantwoord alle vragen en
              onderteken het formulier. Na afronding ontvang je direct een
              bevestiging per mail.
            </p>
          </div>
          <div className="customer_info d-flex justify-content-between align-items-center py-3 px-4 cursor-pointer">
            <div className="d-flex flex-column">
              <h6 className="fw-bold">
                {inputHandle.firstName} {inputHandle.lastName}
              </h6>
              <h6>
                {inputHandle.age} jaar - {inputHandle.city}
              </h6>
              <h6>{inputHandle.email}</h6>
              <h6>{inputHandle.phoneNumber}</h6>
            </div>
            <div className="center_line mx-2"></div>
            <div className="d-flex flex-column gap-1">
              <div className="d-flex gap-3">
                <img src={treatment_icon} alt="" />
                {inputHandle.treatment}
              </div>
              <div className="d-flex gap-3">
                <img src={calendericon} alt="" />
                {formatDateDutch(date)}
              </div>
              <div className="d-flex gap-3">
                <img src={clock_black} alt="" />
                {startTime} uur
              </div>
            </div>
          </div>
          <div className="signature d-flex flex-column justify-content-start align-items-start">
            <h6 className="position-absolute pt-2 ps-3 fw-600 mb-0">
              Handtekening
            </h6>
            <div className="signature_container position-relative w-100">
              {hasExistingSignature && !showNewSignature ? (
                <div className="existing_signature w-100">
                  <img
                    src={hasExistingSignature}
                    alt="Existing Signature"
                    style={{ width: "400px", height: "130px" }}
                  />
                  <div className="new_signature_btn d-flex justify-content-between align-items-center">
                    <p className="mb-0 text-success">
                      ✓ Handtekening reeds opgeslagen
                    </p>
                    <button
                      className="btn btn-sm btn-outline-primary"
                      onClick={clearStoredSignature}
                      type="button"
                    >
                      Nieuwe handtekening
                    </button>
                  </div>
                </div>
              ) : (
                <div className="signature_line w-100">
                  <SignatureCanvas
                    ref={sigCanvasRef}
                    penColor="black"
                    canvasProps={{
                      width: 400,
                      height: 130,
                      className: "sigCanvas"
                    }}
                  />
                  <div className="mt-2 d-flex justify-content-between align-items-center">
                    <button
                      className="reset-signature-btn"
                      style={{ background: "none", border: "none" }}
                      onClick={() => sigCanvasRef.current.clear()}
                      type="button"
                    >
                      Reset
                    </button>
                    {hasExistingSignature && (
                      <button
                        className="btn btn-sm btn-outline-secondary"
                        onClick={() => setShowNewSignature(false)}
                        type="button"
                      >
                        Gebruik vorige handtekening
                      </button>
                    )}
                  </div>
                </div>
              )}
              {signatureError && (
                <p className="signature_error mt-2">
                  Handtekening is verplicht
                </p>
              )}
            </div>
          </div>

          <div className="d-flex align-items-center gap-3">
            <button
              onClick={submit}
              className="payment_btn d-flex align-items-center justify-content-between gap-5 w-100"
              disabled={loading}
            >
              Akkoord & betalen <img src={arrow_white} alt="" />
            </button>
            {loading && <SmallLoader />}
          </div>
        </div>
      </div>
    </div>
  );
};

export default StepThree;
